/**
 * Where a signed-out visit to a protected route is sent.
 *
 * Carries the requested path as `return_to` so sign-in lands the user back on
 * it (Auth.tsx and authRouteReturnTo already honour and same-origin-validate
 * it). A bare `/auth` dropped every deep link — including Shopify App
 * Pricing's post-approval redirect to `/billing?plan_handle=`, the only signal
 * that a plan was approved.
 */
export function authRedirectPath(location: {
  pathname: string;
  search?: string;
  hash?: string;
}): string {
  const target = `${location.pathname}${location.search ?? ''}${location.hash ?? ''}`;
  if (!location.pathname.startsWith('/') || location.pathname.startsWith('//')) return '/auth';
  if (target === '/' || location.pathname === '/auth') return '/auth';
  return `/auth?return_to=${encodeURIComponent(target)}`;
}
